import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { AppBarAppDesktop } from "./AppBar_App_Desktop";
import { AppBarAppMobile } from "./AppBar_App_Mobile";
const AppBarAppWrapper = styled("div")`
  position: sticky;
  top: 0;
  z-index: 3;
`;
const AppBarApp = ()=>{
    return /*#__PURE__*/ _jsxs(AppBarAppWrapper, {
        children: [
            /*#__PURE__*/ _jsx(AppBarAppDesktop, {}),
            /*#__PURE__*/ _jsx(AppBarAppMobile, {})
        ]
    });
};
export default AppBarApp;
